"use strict";
/*********************************************************************
 * Audit Information Platform Component
 * 数据表,默认采用bee-table来实现,也可以用其他表格来实现（如果有更好的表格的话）
 * 2020-08
 * Sunny <tufpsj@yonyou.com>
 *********************************************************************/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
//----- Global ------
var React = require("react");
var react_1 = require("react");
var tinper_bee_1 = require("tinper-bee");
//----- iUAP ------
var filterColumn = require("bee-table/build/lib/filterColumn");
var singleSelect = require("bee-table/build/lib/singleSelect");
var multiSelect = require("bee-table/build/lib/multiSelect");
var sort = require("bee-table/build/lib/sort");
// import sort from "./utils/sort";
var sum_1 = require("./utils/sum");
require("tinper-bee/assets/tinper-bee.css");
var utils_1 = require("./utils");
// 没有高阶函数的定义,不好封装，先罗列出所有组合吧
var MultiSelectTable = multiSelect(sort(tinper_bee_1.Table, tinper_bee_1.Icon, tinper_bee_1.Icon), tinper_bee_1.Checkbox); // 多选功能
// @ts-ignore
var MultiSelectTableWithSum = multiSelect((0, sum_1.sum)(sort(tinper_bee_1.Table, tinper_bee_1.Icon, tinper_bee_1.Icon), 2), tinper_bee_1.Checkbox);
var SingleSelectTable = singleSelect(sort(tinper_bee_1.Table, tinper_bee_1.Icon, tinper_bee_1.Icon), tinper_bee_1.Radio); // 单选功能
var SingleSelectTableWithSum = singleSelect((0, sum_1.sum)(sort(tinper_bee_1.Table, tinper_bee_1.Icon, tinper_bee_1.Icon), 2), tinper_bee_1.Radio);
var MFilterColumnTable = filterColumn(MultiSelectTable, tinper_bee_1.Popover, tinper_bee_1.Icon); // 多选表，带字段过滤
var MFilterColumnTableWithSum = filterColumn(MultiSelectTableWithSum, tinper_bee_1.Popover, tinper_bee_1.Icon);
var SFilterColumnTable = filterColumn(SingleSelectTable, tinper_bee_1.Popover, tinper_bee_1.Icon); // 单选表，带字段过滤
var SFilterColumnTableWithSum = filterColumn(SingleSelectTableWithSum, tinper_bee_1.Popover, tinper_bee_1.Icon);
var SumTableWithoutSelect = (0, sum_1.sum)(sort(tinper_bee_1.Table, tinper_bee_1.Popover, tinper_bee_1.Icon)); // 具有合计行但不能选择记录的表格
var BaseTable = filterColumn(tinper_bee_1.Table, tinper_bee_1.Popover, tinper_bee_1.Icon); // 多选表，带字段过滤
/**
 * 默认的序号列Label显示，默认值是"序号"，可以通过 window.SPECIAL_INDEX_LABEL 来重新定义
 */
var SPECIAL_INDEX_LABEL = window.SPECIAL_INDEX_LABEL || "序号";
/**
 * 表格组件
 *
 * 对于IUAP表格的封装
 */
var AIPTable = /** @class */ (function (_super) {
    __extends(AIPTable, _super);
    function AIPTable(props) {
        var _this = this;
        var _a;
        _this = _super.call(this, props) || this;
        _this.setTitle = function (data) {
            if (_this.props.title && _this.props.title === "") {
                return React.createElement("div", null);
            }
            else {
                return React.createElement("div", { className: "aip-table-title" }, _this.props.title);
            }
        };
        _this.setFooter = function (data) {
            if (_this.props.needFooter) {
                if (_this.props.footer && _this.props.footer !== "") {
                    return React.createElement("div", { className: "aip-table-footer" }, _this.props.footer);
                }
            }
            return React.createElement("div", null);
        };
        /**
         * 点击表格行的事件回调
         * @function
         * @param {any[]} selectedList 已选中数据列表
         * @param {any} record 当前选中的数据
         * @param {number} index 当前选中数据行
         * @param {any} newData 新的数据
         */
        _this._getSelectedDataFunc = function (selectedList, record, index, newData) {
            _this.props.getSelectedDataFunc &&
                _this.props.getSelectedDataFunc(selectedList, record, index, newData);
        };
        /**
         * 表格行双击事件
         * @param record 表格行内容
         * @param index 当前行的序号
         * @param event 事件
         */
        _this._onRowDoubleClick = function (record, index, event) {
            _this.props.onRowDoubleClick &&
                _this.props.onRowDoubleClick(record, index, event);
        };
        _this.state = {
            // single/raw/multiple
            select: props.select || "single",
            bordered: true,
            data: [],
            columns: AIPTable.spliceIndexCols(props.column, props.isTreeTable),
            getSelectedDataFunc: _this._getSelectedDataFunc,
            scroll: { y: _this.props.height || 300 },
            title: _this.setTitle,
            dragborder: true,
            autoCheckedByClickRows: false,
            size: props.size || "md",
            key: props.key || "",
            needSum: props.needSum || false,
            isTreeTable: (_a = props.isTreeTable) !== null && _a !== void 0 ? _a : false,
            footer: _this.setFooter,
            onRowDoubleClick: _this._onRowDoubleClick,
        };
        return _this;
    }
    /**
     * 删除序号列，返回一个新的Columns
     * @function
     * @param {any[]} cols
     * @param {boolean} isTreeTable
     * @returns {any[]}
     */
    AIPTable.spliceIndexCols = function (cols, isTreeTable) {
        if (isTreeTable === void 0) { isTreeTable = false; }
        var special_label = (0, utils_1.getTranslate)(null, SPECIAL_INDEX_LABEL);
        // AIP-Table默认会给每行加上序号，且会更改原有引用，所以，props传递时候，需要确认传递到props的cols不需要有序号字段，这里为了效率考虑，没有深度复制对象
        var indexs = cols.filter(function (item) {
            return item.title === special_label;
        });
        var indexColCount = indexs.length;
        if (isTreeTable) {
            // 树表不需要序号列
            cols.splice(0, indexColCount);
        }
        else {
            cols.splice(0, indexColCount, {
                title: special_label,
                dataIndex: "index",
                key: "index",
                width: 50,
                titleAlign: 'center',
                contentAlign: 'center',
                // fixed: 'left',
                render: function (text, record, index) {
                    // render index number (begin with 1)
                    if (AIPTable.page && AIPTable.limit) {
                        return (AIPTable.page - 1) * AIPTable.limit + index + 1;
                    }
                    return index + 1;
                },
            });
        }
        // cols处理结束
        return cols;
    };
    AIPTable.getDerivedStateFromProps = function (newProp /*, oldState: AIPTableState*/) {
        AIPTable.page = newProp.page;
        AIPTable.limit = newProp.limit;
        var title = newProp.title, height = newProp.height, data = newProp.data, column = newProp.column, page = newProp.page, limit = newProp.limit, footer = newProp.footer, isTreeTable = newProp.isTreeTable, attr = __rest(newProp, ["title", "height", "data", "column", "page", "limit", "footer", "isTreeTable"]);
        var cols = AIPTable.spliceIndexCols(column, isTreeTable);
        return __assign(__assign({}, attr), { data: data, columns: cols });
    };
    AIPTable.prototype.render = function () {
        if (this.props.select && this.props.select === "single") {
            // 单选
            if (this.state.needSum)
                return React.createElement(SFilterColumnTableWithSum, __assign({}, this.state));
            else
                return React.createElement(SFilterColumnTable, __assign({}, this.state));
        }
        else if (this.props.select && this.props.select === "multiple") {
            // 多选
            if (this.state.needSum)
                return React.createElement(MFilterColumnTableWithSum, __assign({}, this.state));
            else
                return React.createElement(MFilterColumnTable, __assign({}, this.state));
        }
        else {
            // 简单表格
            if (this.state.needSum)
                return React.createElement(SumTableWithoutSelect, __assign({}, this.state));
            else
                return React.createElement(BaseTable, __assign({}, this.state));
        }
    };
    AIPTable.page = null;
    AIPTable.limit = null;
    return AIPTable;
}(react_1.PureComponent));
exports.default = AIPTable;
